import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiClock, FiUsers, FiAlertTriangle, FiXCircle } = FiIcons;

const PainPointsSection = () => {
  const problems = [
    {
      icon: FiClock,
      title: "Facturación Tardada",
      description: "Tus clientes tienen que esperar horas o hasta días para obtener su factura. Esto genera quejas y mala experiencia."
    },
    {
      icon: FiUsers,
      title: "Clientes Molestos",
      description: "RFC mal escrito, email mal anotado, o importes incorrectos → Reclamos directos al restaurante que afectan tu reputación."
    },
    {
      icon: FiXCircle,
      title: "Pérdida de Tiempo en Caja",
      description: "Tu personal tiene que detenerse a resolver problemas de facturación en lugar de enfocarse en el servicio y las ventas."
    },
    {
      icon: FiAlertTriangle,
      title: "Riesgo de Multas CFDI 4.0",
      description: "El SAT ahora exige razón social exacta, régimen fiscal y código postal correcto. Un error puede costarte tiempo y dinero."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-red-900 to-orange-800 text-white">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            ¿Te Identificas con Estos <span className="text-yellow-400">Problemas?</span>
          </h2>
          <p className="text-xl max-w-3xl mx-auto opacity-90">
            La mayoría de restaurantes enfrentan estos desafíos de facturación diariamente
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {problems.map((problem, index) => (
            <motion.div
              key={index}
              className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 text-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
            >
              <SafeIcon icon={problem.icon} className="text-4xl text-yellow-400 mb-4 mx-auto" />
              <h3 className="text-lg font-bold mb-3">{problem.title}</h3>
              <p className="text-sm opacity-90">{problem.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 rounded-lg p-8 max-w-4xl mx-auto text-center"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h3 className="text-3xl font-bold mb-4">
            La Solución: Ticket Factura + Inteligencia Artificial
          </h3>
          <p className="text-lg mb-6">
            Aplicando Ticket Factura en tu restaurante:
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm mb-6">
            <div className="bg-white bg-opacity-20 rounded-lg p-4">
              <p className="font-semibold">📲 Factura en segundos con QR</p>
            </div>
            <div className="bg-white bg-opacity-20 rounded-lg p-4">
              <p className="font-semibold">🕒 Disponible todo el mes de consumo</p>
            </div>
            <div className="bg-white bg-opacity-20 rounded-lg p-4">
              <p className="font-semibold">🤝 Atención directa al consumidor (sin distraer a tu personal)</p>
            </div>
            <div className="bg-white bg-opacity-20 rounded-lg p-4">
              <p className="font-semibold">📊 Encuestas de satisfacción incluidas</p>
            </div>
            <div className="bg-white bg-opacity-20 rounded-lg p-4 md:col-span-2 lg:col-span-2">
              <p className="font-semibold">💻 Reportes y descargas automáticas SAT (FinTips)</p>
            </div>
          </div>
          <p className="text-lg font-bold">
            👉 Así conviertes la facturación en una experiencia positiva, fidelizas clientes y ahorras dinero.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default PainPointsSection;